module.exports = __webpack_public_path__ + "img/mal.674a6f28.svg";